import { render, staticRenderFns } from "./addAdPlacement.vue?vue&type=template&id=661feb22&"
import script from "./addAdPlacement.vue?vue&type=script&lang=js&"
export * from "./addAdPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports